(() => {
  if (window.BH3DScale) return;
  const key = 'bh3d-preferred-scale';
  const normalise = value => String(value || '').toLowerCase().replace(/\s+/g, '');
  const label = value => String(value).replace(/\s*mm$/i, ' mm');
  const strings = JSON.parse(document.getElementById('bh3d-scale-strings')?.textContent || '{}');
  const options = [...document.querySelectorAll('[data-bh3d-scale-selector] option')].map(o => o.value);
  const canonical = value => options.find(o => normalise(o) === normalise(value)) || '';
  let scale = '';
  try { scale = canonical(localStorage.getItem(key)); } catch (_) {}
  let applying = false;
  let queued = false;
  const initialised = new WeakSet();
  const priceStates = new WeakMap();
  const scaleField = picker => [...picker.querySelectorAll('.option-selector')].find(e => normalise(e.dataset.option) === 'scale');
  const selected = field => field?.querySelector('.js-option:checked, .js-option[aria-selected="true"]');
  const valueOf = option => option?.dataset.value ?? option?.value ?? '';
  const text = name => (strings[name] || '').replace('__scale__', label(scale));

  function pickerFor(price) {
    const scope = price.closest('.js-product, .product-info, .cc-featured-product');
    const local = scope?.querySelector('variant-picker');
    if (local?.dataset.bh3dProduct === price.dataset.bh3dPrice) return local;
    if (price.closest('.sticky-atc-panel')) return document.querySelector(`variant-picker[data-bh3d-product="${price.dataset.bh3dPrice}"]`);
    return null;
  }

  function exactVariant(picker) {
    if (!picker) return false;
    const choices = [...picker.querySelectorAll('.option-selector:not(.option-selector--custom)')].map(f => valueOf(selected(f)));
    if (choices.some(v => !v)) return false;
    let variant;
    try { variant = JSON.parse(picker.querySelector('script[type="application/json"]')?.textContent || 'null'); } catch (_) { return false; }
    return variant && variant.options.every((v, i) => v === choices[i]) ? variant.id : false;
  }

  function renderPrice(price) {
    const template = price.querySelector(':scope > template[data-bh3d-scale-data]');
    if (!template) return;
    const picker = pickerFor(price);
    const exact = scale && ((picker && normalise(valueOf(selected(scaleField(picker)))) === normalise(scale) && exactVariant(picker)) || (price.closest('.card--related') && normalise(price.dataset.bh3dFixedScale) === normalise(scale)));
    const choices = picker ? [...picker.querySelectorAll('.option-selector:not(.option-selector--custom)')].map(f => valueOf(selected(f))) : [];
    const invalidCombination = scale && picker && choices.every(Boolean) && !picker.querySelector('script[type="application/json"]');
    const signature = `${scale}|${exact || ''}|${choices.join('|')}|${invalidCombination}`;
    if (priceStates.get(price) === signature) return;
    priceStates.set(price, signature);
    price.querySelector(':scope > .bh3d-scale-price')?.remove();
    price.classList.remove('bh3d-scale-applied');
    price.dataset.bh3dScaleReady = 'true';
    if (!scale || exact) return;
    const entry = [...template.content.children].find(e => normalise(e.dataset.scale) === normalise(scale));
    const output = document.createElement('div');
    output.className = 'bh3d-scale-price';
    if (invalidCombination || !entry || entry.dataset.available !== 'true') {
      output.classList.add('bh3d-scale-price--unavailable');
      output.textContent = invalidCombination ? strings.combination : text(entry ? 'soldOut' : 'unavailable');
    } else {
      output.append(...[...entry.childNodes].map(n => n.cloneNode(true)));
      const suffix = document.createElement('span');
      suffix.className = 'bh3d-scale-price__at';
      suffix.textContent = text('at');
      output.append(suffix);
    }
    price.append(output);
    price.classList.add('bh3d-scale-applied');
  }

  function applyPicker(picker) {
    const field = scaleField(picker);
    if (!field || !scale || !picker.hasAttribute('loaded')) return;
    const match = [...field.querySelectorAll('.js-option')].find(o => normalise(valueOf(o)) === normalise(scale));
    if (match === selected(field)) return;
    applying = true;
    try {
      if (match?.matches('input')) {
        match.checked = true;
        match.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { noFocus: true } }));
      } else if (match) {
        const select = match.closest('custom-select');
        const noFocus = event => { if (event.detail) event.detail.noFocus = true; };
        select.addEventListener('change', noFocus, { capture: true, once: true });
        select.selectOption(match);
      } else {
        field.querySelectorAll('input:checked').forEach(o => { o.checked = false; });
        const select = field.querySelector('custom-select');
        if (select) {
          const blank = [...select.querySelectorAll('.js-option')].find(o => valueOf(o) === '');
          if (blank) select.selectOption(blank);
          else {
            select.querySelectorAll('[aria-selected="true"]').forEach(o => o.setAttribute('aria-selected', 'false'));
            if (select.button?.firstElementChild) select.button.firstElementChild.textContent = text('unavailable');
          }
        }
        picker.updateStatusClasses();
        picker.updateAddToCartButton();
      }
    } finally { applying = false; }
  }

  function controls(announce) {
    document.documentElement.toggleAttribute('data-bh3d-scale-active', Boolean(scale));
    document.querySelectorAll('[data-bh3d-scale-selector]').forEach(e => {
      e.value = scale;
      const display = e.parentElement.querySelector('.bh3d-scale-pill__value');
      if (display) {
        const selectedText = e.selectedOptions[0]?.textContent || '';
        if (display.textContent !== selectedText) display.textContent = selectedText;
        e.parentElement.classList.add('bh3d-scale-pill--ready');
      }
    });
    if (announce) document.querySelectorAll('[data-bh3d-scale-status]').forEach(e => { e.textContent = scale ? text('updated') : strings.reset; });
  }

  function setScale(value, source, announce = true) {
    scale = canonical(value);
    try { if (scale) localStorage.setItem(key, scale); else localStorage.removeItem(key); } catch (_) {}
    controls(announce);
    document.querySelectorAll('variant-picker[loaded]').forEach(p => { if (p !== source) applyPicker(p); });
    document.querySelectorAll('[data-bh3d-price]').forEach(renderPrice);
  }

  function scan() {
    queued = false;
    document.querySelectorAll('variant-picker[loaded]').forEach(picker => {
      if (initialised.has(picker)) return;
      initialised.add(picker);
      const explicit = !picker.closest('.js-quickbuy, .cc-featured-product') && new URLSearchParams(location.search).has('variant');
      const chosen = valueOf(selected(scaleField(picker)));
      if (explicit && chosen && !scale) setScale(chosen, picker, false);
      else applyPicker(picker);
    });
    document.querySelectorAll('[data-bh3d-price]').forEach(renderPrice);
  }
  const schedule = () => { if (!queued) { queued = true; setTimeout(scan, 35); } };

  document.addEventListener('change', event => {
    if (event.target.matches('[data-bh3d-scale-selector]')) { setScale(event.target.value); return; }
    const picker = event.target.closest('variant-picker');
    if (!picker || applying) return;
    const field = event.target.closest('.option-selector');
    if (field && normalise(field.dataset.option) === 'scale') {
      const chosen = valueOf(selected(field));
      if (chosen) setScale(chosen, picker);
    }
    schedule();
  });
  document.addEventListener('on:variant:change', schedule);
  document.addEventListener('submit', event => {
    if (!scale || !event.target.matches('.js-product-form')) return;
    if (event.target.closest('.card--related')?.querySelector('.bh3d-scale-applied')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.target.closest('.card--related').querySelector('.js-quick-add')?.click();
      return;
    }
    const picker = event.target.closest('.js-product, .shopify-section')?.querySelector('variant-picker');
    const field = picker && scaleField(picker);
    if (field && (normalise(valueOf(selected(field))) !== normalise(scale) || !exactVariant(picker))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      document.querySelector('[data-bh3d-scale-status]').textContent = strings.choose;
      field.querySelector('input, button')?.focus();
    }
  }, true);
  window.addEventListener('storage', event => { if (event.key === key) setScale(event.newValue, null, false); });
  window.addEventListener('pageshow', () => { try { setScale(localStorage.getItem(key), null, false); } catch (_) { schedule(); } });
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && !n.closest('.bh3d-scale-price') && (n.matches('[data-bh3d-price], variant-picker') || n.querySelector('[data-bh3d-price], variant-picker'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  customElements.whenDefined('variant-picker').then(schedule);
  window.BH3DScale = { refresh: schedule };
  controls(false);
  scan();
})();
